import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SurferIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.25 3.5C7.94036 3.5 8.5 2.94036 8.5 2.25C8.5 1.55964 7.94036 1 7.25 1C6.55964 1 6 1.55964 6 2.25C6 2.94036 6.55964 3.5 7.25 3.5Z"
		></path>
		<path
			fill="currentColor"
			d="M3.57895 6.54404H5.86564C6.62566 6.54404 7.35455 6.24366 7.89196 5.70899L8.21053 5.39205L8.95904 6.13675C9.18514 6.36169 9.18514 6.72639 8.95904 6.95133C8.85047 7.05935 8.70321 7.12003 8.54967 7.12003H6.49426C5.70914 7.12003 5.30849 8.03027 4.98824 8.75784L4.56011 9.72922C4.4739 9.92482 4.39835 10.1277 4.34478 10.3238C4.85696 10.0952 5.43357 9.86773 6.08201 9.64753C6.12658 9.55955 6.17198 9.47195 6.21736 9.38437C6.26326 9.29581 6.30921 9.20715 6.3542 9.11828C6.38777 9.05199 6.41943 8.98745 6.44981 8.92552C6.63335 8.5514 6.77041 8.27202 7 8.27202L7.72333 9.07162C7.74276 9.0931 7.76201 9.11473 7.78108 9.1365C8.26869 9.00797 8.73163 8.90192 9.17037 8.81574L8.78947 8.27202H10.2791C11.0551 8.27202 11.6842 7.64613 11.6842 6.87405C11.6842 6.65703 11.6334 6.44298 11.5359 6.24886L10.5263 4.24006L10.9519 4.3812C11.7774 4.65495 12.4251 5.29938 12.7002 6.12063L12.791 6.39145C12.8248 6.49252 12.8421 6.59835 12.8421 6.70488V7.12003C12.8421 7.43815 13.1013 7.69603 13.4211 7.69603C13.7408 7.69603 14 7.43815 14 7.12003V6.67031C14 6.58645 13.9897 6.5029 13.9692 6.42154L13.7732 5.64132C13.5477 4.74411 12.9732 3.97275 12.1762 3.49693C11.1486 2.88354 9.87725 2.83496 8.80542 3.36814L8.73891 3.40122C8.38894 3.57532 8.06947 3.8044 7.7928 4.07966L7.19311 4.6763C6.73247 5.13459 6.10771 5.39205 5.45627 5.39205H3.57895C3.2592 5.39205 3 5.64993 3 5.96804C3 6.28616 3.2592 6.54404 3.57895 6.54404Z"
		></path>
		<path
			fill="currentColor"
			d="M1 13.342C1.24316 12.9234 2.61125 11.1593 7.25944 9.80039C11.9076 8.44152 14.3566 9.11562 15 9.62252C14.8763 10.5275 13.3699 12.7053 8.33441 14.1775C3.29887 15.6496 1.39868 14.815 1.07803 14.2138L1 13.342Z"
		></path>
	</svg>
))
